<template>
  <v-app class="view">
    <v-dialog
        v-model="EditObjectDialog"
        max-width="1200"
        overlay-opacity="0.8"
        persistent
    >
      <form v-if="selectedObject" @submit.prevent="onSubmitObject">
        <v-card class="pa-2">
          <v-tabs v-model="tab">
            <v-tab>Setting</v-tab>
            <v-tab>Remark</v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab">
            <v-tab-item>
              <v-container class="tab-item" fluid>
                <v-row>
                  <v-col>
                    <v-text-field

                        v-model="selectedObject.name"
                        class="dialog-input"
                        hide-details
                        label="ชื่อ"
                        outlined
                        placeholder=""
                        required
                    >
                    </v-text-field>


                  </v-col>

                </v-row>
                <v-row style="max-height: 380px;overflow: auto">
                  <v-col>

                    <v-treeview
                        v-model="selectedCities"
                        :items="provinces"
                        :load-children="fetchCities"
                        :open="openProvinces"
                        activatable
                        class="province-selecting"
                        open-on-click
                        selectable
                        @input="onChangeCityEnabled"

                    >
                      <template v-slot:prepend="{ item }">
                        <v-icon v-if="!item.children">
                          -
                        </v-icon>
                      </template>
                    </v-treeview>


                    <!--                      <v-treeview-->
                    <!--                          v-model="selectedCities"-->
                    <!--                          :items="items"-->
                    <!--                          item-disabled="locked"-->
                    <!--                          selectable-->
                    <!--                          @click="onChangeCityEnabled"-->
                    <!--                      ></v-treeview>-->


                  </v-col>


                </v-row>

              </v-container>
            </v-tab-item>
            <v-tab-item>
              <v-container class="tab-item" fluid>
                <v-row>
                  <v-col>
                    <v-textarea

                        v-model="selectedObject.remark"
                        class="dialog-input"
                        hide-details
                        label="หมายเหตุ"
                        outlined
                        placeholder=""

                        rows="3"

                    >
                    </v-textarea>

                  </v-col>
                </v-row>
              </v-container>
            </v-tab-item>
          </v-tabs-items>
          <v-btn class="close-button float-left" color="gray" fab tile @click="cancel">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-btn class="float-left mt-4 ml-12" color="" plain small text @click="deletingObject()">
            <v-icon x-small>mdi-delete</v-icon>
            ลบเส้นทาง
          </v-btn>
          <v-btn :loading="objectLoading" class="close-button float-right" color="primary" fab tile type="submit">
            <v-icon>mdi-check-bold</v-icon>
          </v-btn>
          <v-checkbox
              v-model="selectedObject.enabled"
              class="dialog-input  float-right mr-8"
              label="ใช้งาน"
              outlined
          >
          </v-checkbox>
          <div style="clear: both"></div>
        </v-card>
      </form>
    </v-dialog>

    <Menu :drawerWidth="drawer_width"></Menu>
    <v-content>
      <v-container
          :style="{
                        paddingLeft:(12+drawer_width)+'px',
                     }"
          child-flex
          class="container"

          fluid>
        <v-card>
          <v-card-title>
            จัดการเส้นทาง
            <v-spacer></v-spacer>
            <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                hide-details
                label="ค้นหา"
                single-line
            ></v-text-field>
          </v-card-title>
          <v-data-table
              v-if="objects && Array.isArray(objects)"
              :headers="[
                        { text: 'ชื่อ', value: 'name' },
                        { text: 'สถานะ', value: 'enabled' , width: '120px', fixed: true },
                        { text: 'แก้ไข', value: 'edit', width: '80px', fixed: true },
                      ]"
              :items="objects"
              :loading="objectsLoading"

              :search="search"
              class="elevation-1 mb-12 tr-clickable"
              @click:row="editObject"
          >
            <template v-slot:item.edit="{ item }">
              <v-btn class="primary" outlined small @click.stop="editObject(item)">แก้ไข</v-btn>
            </template>
            <template v-slot:item.enabled="{ item }">
              {{ item.enabled ? 'เปิดใช้งาน' : 'ปิด' }}
            </template>
          </v-data-table>
          <v-btn absolute

                 bottom
                 class="close-button float-left"
                 color="primary"
                 fab
                 left @click="newObject">
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-card>


      </v-container>
    </v-content>


  </v-app>
</template>
<style lang="scss" scoped>


.view {
  font-size: 18px;
}

.nav {
  z-index: 1;
}

.container {
  position: relative;
  margin-top: 0;
}

.pad-filter {
  padding: 16px 0 0 24px;
}

.search .v-input__control {
  /*height: 60px;*/
}

.theme--light .list-header-row {
  background: #FFFFFF;
}

.theme--dark .list-header-row {
  background: #000000;
}

.theme--light .primary {
  color: #FFFFFF !important;
}

.tab-item {
  min-height: 500px;
}

</style>
<style lang="scss">
.province-selecting {
  background: red;

  .v-treeview-node {
    display: block;
    float: left;
    min-width: 230px;

    .v-treeview-node__root {

    }

    .v-treeview-node__children {

    }
  }
}
</style>
<script lang="ts">


import Menu from '@/components/Logistic/Menu.vue'
import {SimpleResponse} from '@/models/Model'
import {DataArray} from '@/models/Response'
import {TransportRoute, TransportRouteConst} from '@/models/TransportRoute'
import {Component, Vue} from 'vue-property-decorator'
import LoadingDummy from '../components/LoadingDummy.vue'
import Helper from '../services/Helper.js'

@Component({
  components: {LoadingDummy, Menu},
})
export default class ViewLogisticRoute extends Vue {
  tab = null
  search = ''

  drawer_ratio = 0.15
  drawer_width = 200

  show_password = false

  objects: TransportRoute[] = []

  objectLoading = false
  objectsLoading = false
  EditObjectDialog = false
  selectedObject: TransportRoute | null = null

  TransportRouteConst = TransportRouteConst

  provinces: any = []
  selectedCities: any = []
  openProvinces = []
  activeProvinces = []


  async editObject(object: TransportRoute) {
    this.objectLoading = true
    this.EditObjectDialog = true

    if (object.id) {
      this.selectedObject = await (new TransportRoute()).load<TransportRoute>(object.id)
      if (this.selectedObject) {
        this.selectedCities = this.selectedObject.city_enabled


        let tmp = this.selectedObject.city_enabled
            .map(id => `${id}`.substr(0, 2))
            .filter((v, i, a) => a.indexOf(v) === i)


        // this.openProvinces = tmp

        tmp.forEach(this.preFresh)
      }
    }

    this.objectLoading = false

  }

  async preFresh(province_id) {
    let province_item = this.provinces.filter(province => `${province.id}` == province_id)[0]
    if (!province_item.children || province_item.children.length == 0) {
      await this.fetchCities(province_item)
      this.selectedCities = []
      setTimeout(() => {
        if (this.selectedObject)
          this.selectedCities = this.selectedObject.city_enabled
      }, 0)
    }
  }

  newObject() {
    this.selectedObject = new TransportRoute()
    this.selectedObject.enabled = true
    this.EditObjectDialog = true

  }

  cancel() {

    this.EditObjectDialog = false
  }

  async onSubmitObject() {
    this.objectLoading = true
    const isNew = this.selectedObject?.id === null

    this.selectedObject = Object.setPrototypeOf(this.selectedObject, TransportRoute.prototype)

    if (this.selectedObject) {
      this.selectedObject.city_enabled = this.selectedCities
      try{
        let object = await this.selectedObject.save<TransportRoute>()
        this.$root.$emit('onSuccess', {message: 'บันทึกสำเร็จ'})



        if (isNew) {
          this.objects.push(object)
        } else {
          for (let i in this.objects) {
            if (this.objects[i].id == object.id) {
              this.objects[i] = object
            }
          }
        }
      }catch (e){
        this.$root.$emit('onError', {error: e})
      }
      this.objectLoading = false
    }
    this.selectedObject = null
    this.EditObjectDialog = false
  }

  async deletingObject() {
    this.$confirm('ยืนยันลบข้อมูล?').then(res => {
      if (res) {
        this.deleteObject()
      }
    })

  }

  async onChangeCityEnabled() {
    console.log(this.openProvinces)
  }

  async fetchCities(item) {

    const url = Helper.setting.city.getListAPI + '?province_id=' + item.id
    try {
      var cities = await Helper.get(url).then<{ data: DataArray }>(({data}) => data.data)
      item.children.push(...cities)
    } catch (e) {
      this.$root.$emit('onError', {error: e})
    }

  }

  async fetchProvince() {

    const url = Helper.setting.province.getListAPI
    try {
      var province = await Helper.get(url).then<{ data: DataArray }>(({data}) => data.data)
      this.provinces = province.map(province => ({'id': province.id, 'name': province.name, 'children': []}))
    } catch (e) {
      this.$root.$emit('onError', {error: e})
    }
  }

  async deleteObject() {
    try {
      if (this.selectedObject == null) return
      this.objectLoading = true

      this.selectedObject = Object.setPrototypeOf(this.selectedObject, TransportRoute.prototype)

      const response: SimpleResponse = await this.selectedObject?.delete()

      this.objects = this.objects.filter(object => object.id != this.selectedObject?.id)

      this.selectedObject = null
      this.EditObjectDialog = false

      this.$root.$emit('onSuccess', {message: response.toString()})
    } catch (e) {
      console.log(e)
      this.$root.$emit('onError', {error: e})
    }
    this.objectLoading = false
  }

  async mounted() {
    this.drawer_width = Math.max(80, Math.round(window.innerWidth * this.drawer_ratio))
    console.log('window.innerWidth', window.innerWidth)


    this.refreshTransportRoute().then(() => {
    })

    if (this.provinces.length == 0) {
      this.fetchProvince()
    }


  }

  async refreshTransportRoute() {
    const url = Helper.setting.transportRoute.getListAPI

    try {
      this.objectsLoading = true
      this.objects = await Helper.get(url).then<{ data: DataArray }>(({data}) => data.data)
    } catch (e) {
      this.$root.$emit('onError', {error: e})
    }
    this.objectsLoading = false
  }

}
</script>
